import { generateId } from '@freelancer/datastore/testing/helpers';
import type { SupportCategoryArticle } from './support-category-articles.model';

export interface GenerateSupportCategoryArticleOptions {
  readonly id?: number;
  readonly title?: string;
  readonly seoUrl?: string;
  readonly categoryName?: string;
  readonly canonicalUrl?: string;
  readonly viewType?: string;
  readonly categoryId?: number;
}

export function generateSupportCategoryArticleObject({
  id = generateId(),
  title,
  seoUrl,
  categoryName,
  canonicalUrl,
  viewType = 'freelancer',
  categoryId = generateId(),
}: GenerateSupportCategoryArticleOptions): SupportCategoryArticle {
  return {
    id,
    title: title ?? `Article ${id}`,
    seoUrl,
    categoryName: categoryName ?? `Category ${categoryId}`,
    canonicalUrl,
    viewType,
    categoryId,
  };
}

export function generateSupportCategoryArticleObjects(
  articles: readonly GenerateSupportCategoryArticleOptions[],
): readonly SupportCategoryArticle[] {
  return articles.map(article => generateSupportCategoryArticleObject(article));
}
